import styled, { keyframes } from 'styled-components';

export default styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9009;
  animation: fadeIn 0.2s;

  .modal-background {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    cursor: default;
  }
`;

const contentAnimation = keyframes`
  from {
    transform: translateY(-5px) scale(1.02, 1.02);
  }

  to {
    transform: translateY(0) scale(1, 1);
  }
`;

export const ModalContent = styled.div`
  position: relative;
  flex: 1;
  background-color: #ffffff;
  padding: 60px 80px 70px;
  z-index: 5;
  max-width: 580px;
  max-height: calc(100vh - 30px);
  overflow: auto;
  border-radius: 3px;
  transform: translateY(0) scale(1, 1);
  animation: ${contentAnimation} 0.2s;

  .close-button {
    position: absolute;
    top: 25px;
    right: 25px;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }

  h2 {
    margin-bottom: 30px;
  }

  form {
    & > div {
      position: relative;
      margin-top: 26px;
      margin-bottom: 20px;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    label {
      margin-bottom: 18px;
      font-weight: 500;

      input {
        width: 100%;
        padding: 13px 18px;
        border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
        border-radius: 4px;
        margin-top: 8px;

        &:focus {
          outline: 0;
          border: 1px solid ${({ theme: { colors } }) => colors.grey};
        }
      }
    }
  }

  .disabled-button {
    color: ${({ theme: { colors } }) => colors.lightBlack};
    background-color: ${({ theme: { colors } }) => colors.deepLightGrey};
    border-color: ${({ theme: { colors } }) => colors.deepLightGrey};
    cursor: default;
  }

  .type-toggle {
    position: relative;
    display: block;
    color: ${({ theme: { colors } }) => colors.blue};
    border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
    border-radius: 4px;
    width: 100%;
    color: inherit;
    text-align: left;
    padding: 15px;
    margin-top: 8px;

    .expand-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 15px;
    }
  }

  .type-content {
    .separator {
      background-color: ${({ theme: { colors } }) => colors.deepLightGrey};
      height: 35px;
      width: 1px;
      margin: 0 20px 0 15px;
      float: left;
    }

    .floating-icon {
      height: 38px;
      float: left;
    }

    .coming-soon {
      position: absolute;
      display: inline-block;
      top: calc(50% - 9px);
      transform: translateY(-50%);
      left: 208px;
      background-color: ${({ theme: { colors } }) => colors.orange};
      color: #ffffff;
      font-weight: 400;
      padding: 3px 5px;
      border-radius: 4px;
      margin-left: 12px;
      font-size: 11px;
      line-height: 1;
    }

    &--text {
      display: inline-block;
      margin-top: 2px;

      &-detail {
        font-size: 12px;
        opacity: 0.6;
      }
    }
  }

  .type-options {
    position: absolute;
    z-index: 4;
    top: 60px;
    right: -10px;
    left: -10px;
    background-color: #ffffff;
    padding: 7px 0;
    list-style: none;
    margin: 0;
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.08);
    min-width: 115px;
    border-radius: 3px;
    text-align: left;
    transition: all 0.1s;
    opacity: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    transform: scale(0.95);
    transform-origin: top;
    pointer-events: none;

    &--close {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
      width: 100%;
      cursor: default;
    }

    &.active {
      opacity: 1;
      transform: scale(1);
      pointer-events: all;
      transition: all 0.2s;
    }

    li {
      display: block;
      padding: 0;
      margin: 0;

      button {
        display: block;
        width: 100%;
        text-align: left;
        padding: 10px 15px;
        transition: ${({ theme: { transition } }) => transition};

        &:hover {
          background-color: rgba(0, 118, 240, 0.05);
        }

        &:focus {
          background-color: rgba(0, 118, 240, 0.1);
        }

        &:hover,
        &:focus {
          color: ${({ theme: { colors } }) => colors.textHighlightColor};
        }

        span,
        br {
          pointer-events: none;
        }

        &.type-button-selected,
        &.type-button-inactive {
          position: relative;

          &::before {
            content: '';
            position: absolute;
            top: 50%;
            right: 15px;
            border-radius: 50%;
            width: 16px;
            height: 16px;
            border: 1px solid ${({ theme: { colors } }) => colors.blue};
            transform: translateY(-50%);
          }
        }

        &.type-button-selected {
          &::before {
            border: 5px solid ${({ theme: { colors } }) => colors.blue};
          }
        }

        &:disabled {
          pointer-events: none;

          span,
          svg,
          &::before {
            opacity: 0.4;
          }

          .coming-soon {
            opacity: 1;
          }
        }
      }
    }
  }

  button[type='submit'] {
    padding: 14px 15px;
  }

  .share-toggle {
    position: absolute;
    right: 13px;
    top: 25px;
    border-left: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
    height: 43px;
    padding-left: 14px;

    svg {
      margin-left: 5px;
    }

    &.active {
      &::before {
        content: '';
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        cursor: default;
      }
    }
  }

  .share-options {
    width: 130px;
    right: 0;
    left: auto;
    top: 24px;
  }
`;
